import React from "react"
import { MenuItem, TextField, Box, TextFieldProps } from "@mui/material"

import MeasureCylinderDialog from "components/Dialogs/MeasureCylinderDialog"

import useInnerLengthsByOuterLengthsConfiguration from "@secureo/common/hooks/cylinderConfigurations/useInnerLengthsByOuterLengthsConfiguration"

import { InnerLengthsByOuterLengths } from "@secureo/common/typings/Product"

const InnerAndOuterLengthConfigurationInput = ({
	innerLengthsByOuterLengths,
	selectedOuterLength,
	selectedInnerLength,
	onOuterLengthChange,
	onInnerLengthChange,
	showMeasureCylinderDialog = false,
	disabled,
	margin = "normal",
}: Props) => {
	const {
		availableOuterLengths,
		availableInnerLengths,
		outerLengthInputProps,
		innerLengthInputProps,
	} = useInnerLengthsByOuterLengthsConfiguration(
		innerLengthsByOuterLengths,
		selectedOuterLength,
		selectedInnerLength,
		onOuterLengthChange,
		onInnerLengthChange,
	)

	return (
		<>
			{showMeasureCylinderDialog && (
				<Box mb={-1} style={{ display: "flex", alignItems: "center" }}>
					<MeasureCylinderDialog />
				</Box>
			)}
			<div style={{ display: "flex", alignItems: "center" }}>
				<div style={{ width: "50%" }}>
					<TextField
						id="outerLength"
						label="Aussenlänge"
						{...outerLengthInputProps}
						margin={margin}
						variant="filled"
						select
						fullWidth
						disabled={disabled}
					>
						{availableOuterLengths.map((outerLength) => (
							<MenuItem key={outerLength} value={outerLength}>
								{outerLength} mm
							</MenuItem>
						))}
					</TextField>
				</div>
				<Box ml={1} style={{ width: "50%" }}>
					<TextField
						id="innerLength"
						label="Innenlänge"
						{...innerLengthInputProps}
						margin={margin}
						variant="filled"
						select
						fullWidth
						disabled={disabled}
					>
						{availableInnerLengths.map((innerLength) => (
							<MenuItem key={innerLength} value={innerLength}>
								{innerLength} mm
							</MenuItem>
						))}
					</TextField>
				</Box>
			</div>
		</>
	)
}

interface Props {
	innerLengthsByOuterLengths: InnerLengthsByOuterLengths
	selectedOuterLength: number
	selectedInnerLength: number
	onOuterLengthChange: (selectedOuterLength: number) => void
	onInnerLengthChange: (selectedInnerLength: number) => void
	showMeasureCylinderDialog?: boolean
	disabled?: boolean
	margin?: TextFieldProps["margin"]
}

export default InnerAndOuterLengthConfigurationInput
